var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshStatusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 6.55859C14.375 6.55859 15.4693 6.01953 11.5 6.01953C10.0785 6.01953 8.68882 6.44107 7.50684 7.23084C6.32486 8.02062 5.40362 9.14315 4.85962 10.4565C4.31561 11.7698 4.17328 13.215 4.45061 14.6092C4.72794 16.0035 5.41248 17.2842 6.41767 18.2894C7.42286 19.2946 8.70355 19.9791 10.0978 20.2564C11.492 20.5338 12.9372 20.3914 14.2505 19.8474C15.5639 19.3034 16.6864 18.3822 17.4762 17.2002C18.266 16.0182 18.6875 14.6286 18.6875 13.207",
    stroke: "white",
    strokeWidth: 1.4375,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.60547L15.0938 6.19922L11.5 9.79297",
    stroke: "white",
    strokeWidth: 1.4375,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshStatusIcon);
export default __webpack_public_path__ + "static/media/RefreshStatusIcon.cbd9edd265f2eebc46331276ab0685e4.svg";
export { ForwardRef as ReactComponent };